<!-- 发放通用券接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "couponTemplateCode" : "8S2XDOBHLGU6",
                "carNo" : "粤A12345"
            },
            responseCode: {
                "data": {
                    "couponSn": "20190429113401000001"
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台给指定车牌发放城市运营券，车辆在停车场可使用优惠券抵扣部分或全部停车费用",
                t_url: this.commonUrls.test+"grantCityOperationCoupon",
                p_url: this.commonUrls.prod+"grantCityOperationCoupon",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponTemplateCode', info2: '是', info3: 'String', info4: '券模板编码' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号(车牌号和用户手机号, 必填其中一个)' },
                        { info1: 'mobile', info2: '否', info3: 'String', info4: '用户手机号(车牌号和用户手机号, 必填其中一个)' },
                        { info1: 'validTo', info2: '否', info3: 'String', info4: '有效结束时间(yyyy-MM-dd HH:mm:ss)' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponSn', info2: '是', info3: 'String', info4: '发放的券编码（对账使用）' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/cityOperationCoupon/grantCityOperationCoupon.vue